/**
 * 카드 기본 클릭 영역은 절대 위치의 링크 하나가 덮는다(`QuizListItem` 의 `CardWrapper`). 그 위에서 따로
 * 눌려야 하는 것(메뉴·작성자·폴더 태그·호버 버튼·LTI 버튼)은 이 클래스로 링크보다 위에 둔다.
 * 새 상호작용 자식을 넣을 때도 같은 클래스를 준다.
 */
export const CARD_ACTION_LAYER = 'relative z-10';
